import React from "react";
import { Link } from "gatsby";

const DemoButton = ({scrollToForm, classes, children }) => {
  // console.log(typeof scrollToForm, scrollToForm);
  // console.log(typeof children, children);
 
  let button = "";
  switch (typeof scrollToForm) {
    case "function":
      button = (
        <button
          onClick={scrollToForm}
          className={`${classes?.join(" ")} demo-button`}
        >
          {children}
        </button>
      );
      break;
    case "string":
    default:
      button = (
        <Link
          to={"/schedule-a-demo/"}
          className={`${classes?.join(" ")} demo-button`}
        >
          {children}
        </Link>
      );
      break;
  }
  return <>{button}</>;
};

export default DemoButton;
